<template>
  <v-card color="primary" class="rounded-sm">
    <v-card-text>
      <v-container>
        <v-form v-model="cupForm" ref="form">
          <v-row>
            <v-col cols="12">
              <BaseInput v-model="cupFormData.cup">
                <template v-slot:label>CUP</template>
              </BaseInput>
              <v-menu
                v-model="menuVigenciaCup"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="vigenciaCupFormatted"
                    label="Vigencia CUP"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="primary"
                    hint="Formato de fecha: DD/MM/YYYY"
                  />
                </template>
                <v-date-picker
                  v-model="cupFormData.vigenciaCup"
                  @input="menuVigenciaCup = false"
                  locale="es"
                  no-title
                ></v-date-picker>
              </v-menu>

              <v-file-input
                v-model="cupFormData.urlAdjunto"
                label="Oficio adjunto"
                rounded
                filled
                background-color="primary"
                color="secondary"
                dense
                accept=".pdf"
              ></v-file-input>

              <v-textarea
                label="Observaciones"
                v-model="cupFormData.observaciones"
                no-resize
                rows="4"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton @click="triggerSaveCup()" :loading="loading">Registrar CUP</TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'
import moment from 'moment'

export default {
  components: {
    BaseInput,
    TextButton,
  },
  props: {
    idPersonal: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      cupForm: false,
      loading: false,
      menuVigenciaCup: false,
      cupFormData: {
        cup: '',
        vigenciaCup: '',
        observaciones: '',
        urlAdjunto: null,
      },
    }
  },
  computed: {
    vigenciaCupFormatted() {
      return this.cupFormData.vigenciaCup ? moment(this.cupFormData.vigenciaCup, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    },
  },
  methods: {
    ...mapActions('cups', ['createCup']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async triggerSaveCup() {
      try {
        this.loading = true

        // Crear el objeto FormData
        let formData = new FormData()
        formData.append('cup', this.cupFormData.cup)
        formData.append(
          'vigenciaCup',
          moment(this.cupFormData.vigenciaCup, 'YYYY-MM-DD').format('DD/MM/YYYY HH:mm:ss a')
        )
        formData.append('observaciones', this.cupFormData.observaciones || '')
        formData.append('fk_idPersonal', this.idPersonal)

        // Adjuntar el archivo si existe
        if (this.cupFormData.urlAdjunto) {
          formData.append('adjunto', this.cupFormData.urlAdjunto)
        }

        // Llamar a la acción del store
        await this.createCup({ idPersonal: this.idPersonal, payload: formData })

        // Reiniciar el formulario y cerrar el modal
        this.resetForm()
        this.$emit('close')
      } catch (error) {
        console.error('Ocurrió un error al registrar el CUP:', error)
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al registrar el CUP.')
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.cupFormData = {
        cup: '',
        vigenciaCup: '',
        observaciones: '',
        urlAdjunto: null,
      }
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>
